import { render, staticRenderFns } from "./Account.vue?vue&type=template&id=404db0dd&scoped=true"
var script = {}
import style0 from "./Account.vue?vue&type=style&index=0&id=404db0dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404db0dd",
  null
  
)

export default component.exports